export default defineNuxtPlugin((nuxtApp) => {
  if (process.client) {
    // Извлекаем хэш из URL
    const hash = window.location.hash;
    if (hash && hash.includes('tgWebAppData')) {
      // Парсим данные из хэша
      const params = new URLSearchParams(hash.replace('#', ''));
      const tgWebAppData = params.get('tgWebAppData');
      
      // Устанавливаем данные в window.Telegram.WebApp.initData
      window.Telegram = window.Telegram || {};
      window.Telegram.WebApp = window.Telegram.WebApp || {};
      window.Telegram.WebApp.initData = tgWebAppData || '';
    }
  }
});